// tslint:disable:max-line-length
import * as React from 'react';

import { createIcon } from '../icon';

export const CianGroupPure = createIcon(`
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
     viewBox="0 0 135 28" style="enable-background:new 0 0 135 28;" xml:space="preserve">
    <style type="text/css">
      .st0{fill:#737A8E;}
      .st1{enable-background:new    ;}
    </style>
    <g>
      <g>
        <path class="st0" d="M11.8,0.9c-2.1,0-3.7,1.7-3.7,3.7c0,0.7,0.2,1.4,0.5,1.9c0.1,0.1,0.1,0.2,0.2,0.3L9,7.1l2.7,3.3l3-3.6
          c0.5-0.6,0.8-1.4,0.8-2.3C15.6,2.6,13.9,0.9,11.8,0.9z M11.8,6.4c-0.9,0-1.7-0.8-1.7-1.7S10.9,3,11.8,3c0.9,0,1.7,0.8,1.7,1.7
          S12.8,6.4,11.8,6.4z"/>
        <polygon class="st0" points="13.3,18.3 13.3,12 10.5,12 10.5,15 7.7,11.7 0,20.9 2.6,23.1 7.7,16.9 12.9,23.1 15.4,20.9     "/>
        <g>
          <polygon class="st0" points="30.3,12 27.8,12 27.8,20.6 22.9,20.6 22.9,12 20.5,12 20.5,22.9 29.5,22.9 29.5,25 31.8,25
            31.8,20.6 30.3,20.6       "/>
          <polygon class="st0" points="35.9,19.3 35.9,12 33.5,12 33.5,22.9 35.9,22.9 41.1,15.6 41.1,22.9 43.6,22.9 43.6,12 41.1,12
            "/>
          <polygon class="st0" points="64.7,12 64.7,16.3 59.7,16.3 59.7,12 57.3,12 57.3,22.9 59.7,22.9 59.7,18.6 64.7,18.6 64.7,22.9
            67.2,22.9 67.2,12       "/>
          <path class="st0" d="M50.4,11.8c-1.3,0-2.4,0.3-3.2,1c-0.8,0.6-1.2,1.5-1.3,2.4h2.4c0.1-0.5,0.6-1.3,2-1.3c1.3,0,2.1,0.8,2.1,2.1
            l0,0H50c-1.5,0-2.6,0.3-3.4,1c-0.7,0.6-1.1,1.5-1.1,2.6c0,1,0.4,1.8,1.1,2.5c0.7,0.6,1.7,1,2.9,1c1.8,0,2.8-0.9,3.1-1.3l0.2,0.9
            v0.1h0.1h1.8h0.2v-0.2V16C54.9,13.4,53.1,11.8,50.4,11.8z M52.4,18.3c0,0.9-0.2,1.5-0.7,2S50.5,21,49.6,21
            c-1.1,0-1.7-0.5-1.7-1.4c0-1,0.8-1.5,2.2-1.5h2.4L52.4,18.3C52.5,18.3,52.4,18.3,52.4,18.3z"/>
        </g>
      </g>
      <g class="st1">
        <path class="st0" d="M77.4,12.1h7.2v1.5h-5.4v9.2h-1.8C77.4,22.8,77.4,12.1,77.4,12.1z"/>
        <path class="st0" d="M88.6,21v5.8h-1.8V12.1h1.6l0.1,2.1c0.8-1.4,2.1-2.2,3.9-2.2c2.9,0,4.7,2.4,4.7,5.6s-1.8,5.6-4.7,5.6
          C90.7,23.1,89.4,22.3,88.6,21z M95.3,17.5c0-2.3-1.1-4-3.3-4c-2.1,0-3.4,1.8-3.4,4.1s1.3,4,3.4,4C94.2,21.5,95.3,19.8,95.3,17.5z"
          />
        <path class="st0" d="M108.6,12.1L104,23.8c-0.8,2.2-1.8,3.2-3.5,3.2c-0.4,0-0.8-0.1-1.2-0.2l-0.1-1.4c0.3,0.1,0.6,0.1,0.9,0.1
          c1.3,0,1.8-0.6,2.6-2.4l0.2-0.4l-4.4-10.6h1.9l3.3,8.5l3.1-8.5H108.6z"/>
        <path class="st0" d="M110.8,12.1h9.3v10.7h-1.8v-9.2h-5.7v9.2h-1.8V12.1z"/>
        <path class="st0" d="M123.8,12.1h9.3v10.7h-1.8v-9.2h-5.7v9.2h-1.8V12.1z"/>
      </g>
      <path class="st0" d="M70.9,20.8h2v2.1h-2V20.8z"/>
    </g>
  </svg>
`);

export const CianGroupIcon: React.FC<{ iconClassName?: string }> = (props: { iconClassName?: string }) => (
  <CianGroupPure className={props.iconClassName} />
);

CianGroupIcon.displayName = 'CianGroupIcon';
